import script from "./DesktopLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopLayout.vue?vue&type=script&setup=true&lang=js"

import "./DesktopLayout.vue?vue&type=style&index=0&id=48e347d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e347d2"]])

export default __exports__